import { gql } from "@apollo/client";

export const USER_UPDATE_USERNAME = gql`
  mutation UserUpdateUsername($input: UserUpdateUsernameInput!) {
    userUpdateUsername(input: $input) {
      clientMutationId
      errors {
        code
        field
        message
      }
      viewer {
        id
        username
      }
    }
  }
`;
